import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModelInvoice } from 'src/app/entities/invoices';

@Component({
  selector: 'app-dati-trasporto',
  templateUrl: './dati-trasporto.component.html',
  styleUrls: ['./dati-trasporto.component.css']
})
export class DatiTrasportoComponent implements OnInit, OnChanges {

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Input() model : ModelInvoice | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();

  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1, 
        name: "invoices.edit.transportData.other.tabs.tab1"
      },
      {
        id: 2,
        name: "invoices.edit.transportData.other.tabs.tab2"
      },
      {
        id: 3,
        name: "invoices.edit.transportData.other.tabs.tab3"
      }
    ]
  }


  constructor(private modalService: NgbModal) {
    this.innerWidth = window.innerWidth;
  }

  async ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.model){
      this.model = changes.model.currentValue;
    }
  }
  public checkPersonaFisica(event: any){
      this.model!.FatturaElettronicaBody.DatiGenerali.DatiTrasporto.DatiAnagraficiVettore.Anagrafica.PersonaFisica = event.target.checked ? 1 : 0;
  }
  
  public notifyChange(){
    this.modelChange.emit(this.model);
  }
}
